import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { parseFilmSearch } from "@tour/film.js";
import { hasAgentAccess, hasBrokerAccess } from "../auth/authService";
import { useAuth } from "./useAuth";

const DEMO = {
  agent: { email: "agent@dreamhome.local", password: "demo123" },
  broker: { email: "broker@dreamhome.local", password: "demo123" },
};

export function useFilmDesk(need) {
  const { search } = useLocation();
  const film = parseFilmSearch(search);
  const { role, login } = useAuth();
  const allowed = need === "broker" ? hasBrokerAccess(role) : hasAgentAccess(role);
  const [pending, setPending] = useState(Boolean(film.on && !allowed));

  useEffect(() => {
    if (!film.on || allowed) {
      setPending(false);
      return undefined;
    }
    let live = true;
    setPending(true);
    login(DEMO[need], need)
      .catch(() => {})
      .finally(() => {
        if (live) setPending(false);
      });
    return () => {
      live = false;
    };
    // login identity is not stable; film.on / allowed / need are the gates
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowed, film.on, need]);

  return { filmOn: film.on, allowed, pending };
}
